import * as types from '../types';

const actions = {};

// GET SCORM PROGRESS
actions.getScormProgressRequest = (registrationId, repoId) => {
    return {
        type: types.GET_SCORM_PROGRESS_REQUEST,
        payload: { registrationId, repoId },
    };
};

actions.getScormProgressSuccess = (progress) => {
    return {
        type: types.GET_SCORM_PROGRESS_SUCCESS,
        payload: progress,
    };
};

actions.getScormProgressFail = (error) => {
    return {
        type: types.GET_SCORM_PROGRESS_FAIL,
        payload: error,
    };
};

export { actions };
